module.exports = __webpack_public_path__ + "static/media/tavatar-victoria.6d1b05e6.jpg";